/*
 * @Author: your name
 * @Date: 2022-02-25 14:57:50
 * @LastEditTime: 2024-09-26 11:02:27
 * @LastEditors: zhangyuan your_email
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /report-template/src/router/index.ts
 */
import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'

const index = () => import('@/views/Index/index.vue')
const h5 = () => import('@/views/h5/index.vue')
const toc = () => import('@/views/toc/index.vue')
const tocPhotoList = () => import('@/views/toc/photoList.vue')
const h5PhotoList = () => import('@/views/h5/photoList.vue')
const explain = () => import('@/views/h5/serviceExplain.vue')
const pdfView = () => import('@/views/h5/pdfView.vue')
const viewPDF = () => import('@/views/viewPDF/pdfView.vue')
const ecu = () => import('@/views/h5/ecuDetail.vue')
// 闲鱼报告
const idlefish = () => import('@/views/idlefish/index.vue')
const explainIdleFish = () => import('@/views/idlefish/serviceExplain.vue')
const brandIntroduction = () => import('@/views/idlefish/brandIntroduction.vue')
const fishPhotoList = () => import('@/views/idlefish/photoList.vue')
// 无报告
const deffectiveReport = () => import('@/views/h5/deffectiveReport.vue')
// H5 2022年3月升级
const explainFreeCheck = () => import('@/views/toc/freeCheckService.vue')
const ecuToC = () => import('@/views/toc/ecuDetail.vue')
const explainFreeAuth = () => import('@/views/toc/freeAuthService.vue')
const checkStandard = () => import('@/views/toc/checkStandard.vue')

// h5 2022年10月升级
const tocV3 = () => import('@/views/tocV3/index.vue')
const tocV3CarInfo = () => import('@/views/tocV3/carInfo.vue')
const tocV3PhotoList = () => import('@/views/tocV3/photoList.vue')
const tocV3ExplainFreeCheck = () => import('@/views/tocV3/freeCheckService.vue')
const tocV3CheckStandard = () => import('@/views/tocV3/checkStandard.vue')

// h5 2023年8月升级 tocV4
const tocV4 = () => import('@/views/tocV4/index.vue')
const tocV4CarInfo = () => import('@/views/tocV4/carInfo.vue')
const tocV4PhotoList = () => import('@/views/tocV4/photoList.vue')
const tocV4ExplainFreeCheck = () => import('@/views/tocV4/freeCheckService.vue')
const tocV4CheckStandard = () => import('@/views/tocV4/checkStandard.vue')
const tocV4explainFreeAuth = () => import('@/views/tocV4/freeAuthService.vue')

// h5 中汽研报告 2023年10月升级 tocZQY
const tocZQY = () => import('@/views/tocZQY/index.vue')
const tocZQYCarInfo = () => import('@/views/tocZQY/carInfo.vue')
const tocZQYPhotoList = () => import('@/views/tocZQY/photoList.vue')
const tocZQYExplainFreeCheck = () => import('@/views/tocZQY/freeCheckService.vue')
const tocZQYCheckStandard = () => import('@/views/tocZQY/checkStandard.vue')

// h5 收车检报告 2024年4月升级 tocSCJ
const tocSCJ = () => import('@/views/tocSCJ/index.vue')
const tocSCJCarInfo = () => import('@/views/tocSCJ/carInfo.vue')
const tocSCJPhotoList = () => import('@/views/tocSCJ/photoList.vue')
const tocSCJExplainFreeCheck = () => import('@/views/tocSCJ/freeCheckService.vue')
const tocSCJCheckStandard = () => import('@/views/tocSCJ/checkStandard.vue')

// h5 腾发报告 2024年9月升级 tocTF
const tocTF = () => import('@/views/tocTF/index.vue')
const tocTFCarInfo = () => import('@/views/tocTF/carInfo.vue')
const tocTFPhotoList = () => import('@/views/tocTF/photoList.vue')
const tocTFExplainFreeCheck = () => import('@/views/tocTF/freeCheckService.vue')
const tocTFCheckStandard = () => import('@/views/tocTF/checkStandard.vue')
const tocTFExplainFreeAuth = () => import('@/views/tocTF/freeAuthService.vue')
const tocTFEcuDetail = () => import('@/views/tocTF/ecuDetail.vue')


// h5 T9新车
const tocT9 = () => import('@/views/tocT9/index.vue')
const tocT9PhotoList = () => import('@/views/tocT9/photoList.vue')
const tocT9ExplainFreeCheck = () => import('@/views/tocT9/freeCheckService.vue')
const tocT9CheckStandard = () => import('@/views/tocT9/checkStandard.vue')
const tocT9ExplainFreeAuth = () => import('@/views/tocT9/freeAuthService.vue')
// SDK里面的报告预览
const reportConfirm = () => import('@/views/reportConfirm/index.vue')
// 拆解教程
const apartCourse = () => import('@/views/apartCourse/index.vue')

// 查看照片
const photoView = () => import('@/views/photoView/index.vue');
// 复检差异
const redetect = () => import('@/views/redetect/index.vue');
const routes: Array<RouteRecordRaw> = [
    {
        path: '',
        redirect: '/Index',
        meta:{title: "检测报告"}
    },
    {
        path: '/Index',
        name: 'index',
        component: index,
        meta:{title:"检测报告"}
    },
    {
        path: '/h5',
        name: 'h5',
        component: h5,
        meta:{title: "检测报告"}
    },
    {
        path: '/toc',
        name: 'toc',
        component: toc,
        meta:{title: "检测报告"}
    },
    {
        path: '/tocV3',
        name: 'tocV3',
        component: tocV3,
        meta:{
            title: "检测报告",
            keepAlive: true
        },
    },
    {
        path: '/tocV3PhotoList',
        name: 'tocV3PhotoList',
        component: tocV3PhotoList,
        meta:{title: "检测报告"}
    },
    {
        path: '/carInfo',
        name: 'tocV3CarInfo',
        component: tocV3CarInfo,
        meta:{title: "车辆信息"}
    },
    {
        path: '/tocV4',
        name: 'tocV4',
        component: tocV4,
        meta:{
            title: "检测报告",
            keepAlive: true
        },
    },
    {
        path: '/tocV4PhotoList',
        name: 'tocV4PhotoList',
        component: tocV4PhotoList,
        meta:{title: "检测报告"}
    },
    {
        path: '/carInfo',
        name: 'tocV4CarInfo',
        component: tocV4CarInfo,
        meta:{title: "车辆信息"}
    },
    {
        path: '/tocPhotoList',
        name: 'tocPhotoList',
        component: tocPhotoList,
        meta:{title: "检测报告"}
    },
    {
        path: '/explain',
        name: 'explain',
        component: explain,
        meta: {title: "检测报告"}
    },
    {
        path: '/pdfView',
        name: 'pdfView',
        component: pdfView,
        meta: {title: "检测报告"}
    },
    {
        path: '/viewPDF',
        name: 'viewPDF',
        component: viewPDF,
        meta: {title: "检测报告"}
    },
    {
        path: '/ecu',
        name: 'ecu',
        component: ecu,
        meta: {title: "检测报告"}
    },
    {
        path: '/h5PhotoList',
        name: 'h5PhotoList',
        component: h5PhotoList,
        meta:{title: "检测报告"}
    },
    // 闲鱼报告
    {
        path: '/idlefish',
        name: 'idlefish',
        component: idlefish,
        meta: {title: "验货报告"}
    },
    {
        path: '/idlefishExplain',
        name: 'idlefish-explain',
        component: explainIdleFish,
        meta: {title: "验货报告"}
    },
    {
        path: '/idlefishIntroduction',
        name: 'idlefish-introduction',
        component: brandIntroduction,
        meta: {title: "验货报告"}
    },
    {
        path: '/idlefishPhotoList',
        name: 'idlefish-PhotoList',
        component: fishPhotoList,
        meta: {title: "验货报告"}
    },
    {
        path: '/deffectiveReport',
        name: 'deffectiveReport',
        component: deffectiveReport,
        meta: {title: "报告已失效"}
    },
    // H5报告升级后
    {
        path: '/explainFreeCheck',
        name: 'explainFreeCheck',
        component: explainFreeCheck,
        meta: {title: "268V检测报告"}
    },
    // tocv3报告升级后
    {
        path: '/tocV3ExplainFreeCheck',
        name: 'tocV3ExplainFreeCheck',
        component: tocV3ExplainFreeCheck,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocV4ExplainFreeCheck',
        name: 'tocV4ExplainFreeCheck',
        component: tocV4ExplainFreeCheck,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/ecuToC',
        name: 'ecuToC',
        component: ecuToC,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/explainFreeAuth',
        name: 'explainFreeAuth',
        component: explainFreeAuth,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/checkStandard',
        name: 'checkStandard',
        component: checkStandard,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocV3CheckStandard',
        name: 'tocV3CheckStandard',
        component: tocV3CheckStandard,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocV4CheckStandard',
        name: 'tocV4CheckStandard',
        component: tocV4CheckStandard,
        meta: {title: "268V检测报告"}
    },
    // 中汽研报告
    {
        path: '/tocZQY',
        name: 'tocZQY',
        component: tocZQY,
        meta:{
            title: "检测报告",
            keepAlive: true
        },
    },
    {
        path: '/tocZQYPhotoList',
        name: 'tocZQYPhotoList',
        component: tocZQYPhotoList,
        meta:{title: "检测报告"}
    },
    {
        path: '/carInfo',
        name: 'tocZQYCarInfo',
        component: tocZQYCarInfo,
        meta:{title: "车辆信息"}
    },
    {
        path: '/tocZQYExplainFreeCheck',
        name: 'tocZQYExplainFreeCheck',
        component: tocZQYExplainFreeCheck,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocZQYCheckStandard',
        name: 'tocZQYCheckStandard',
        component: tocZQYCheckStandard,
        meta: {title: "268V检测报告"}
    },
    // 收车检报告
    {
        path: '/tocSCJ',
        name: 'tocSCJ',
        component: tocSCJ,
        meta:{
            title: "检测报告",
            keepAlive: true
        },
    },
    {
        path: '/tocSCJPhotoList',
        name: 'tocSCJPhotoList',
        component: tocSCJPhotoList,
        meta:{title: "检测报告"}
    },
    {
        path: '/tocSCJcarInfo',
        name: 'tocSCJCarInfo',
        component: tocSCJCarInfo,
        meta:{title: "车辆信息"}
    },
    {
        path: '/tocSCJExplainFreeCheck',
        name: 'tocSCJExplainFreeCheck',
        component: tocSCJExplainFreeCheck,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocSCJCheckStandard',
        name: 'tocSCJCheckStandard',
        component: tocSCJCheckStandard,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocV4explainFreeAuth',
        name: 'tocV4explainFreeAuth',
        component: tocV4explainFreeAuth,
        meta: {title: "268V检测报告"}
    },
    // 腾发报告
    {
        path: '/tocTF',
        name: 'tocTF',
        component: tocTF,
        meta:{
            title: "检测报告",
            keepAlive: true
        },
    },
    {
        path: '/tocTFPhotoList',
        name: 'tocTFPhotoList',
        component: tocTFPhotoList,
        meta:{title: "检测报告"}
    },
    {
        path: '/tocTFcarInfo',
        name: 'tocTFCarInfo',
        component: tocTFCarInfo,
        meta:{title: "车辆信息"}
    },
    {
        path: '/tocTFExplainFreeCheck',
        name: 'tocTFExplainFreeCheck',
        component: tocTFExplainFreeCheck,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocTFCheckStandard',
        name: 'tocTFCheckStandard',
        component: tocTFCheckStandard,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocTFexplainFreeAuth',
        name: 'tocTFExplainFreeAuth',
        component: tocTFExplainFreeAuth,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocTFEcuDetail',
        name: 'tocTFEcuDetail',
        component: tocTFEcuDetail,
        meta: {title: "268V检测报告"}
    },
     // T9新车报告
    {
        path: '/tocT9',
        name: 'tocT9',
        component: tocT9,
        meta:{
            title: "检测报告",
            keepAlive: true
        },
    },
    {
        path: '/tocT9PhotoList',
        name: 'tocT9PhotoList',
        component: tocT9PhotoList,
        meta:{title: "检测报告"}
    },
    {
        path: '/tocT9ExplainFreeCheck',
        name: 'tocT9ExplainFreeCheck',
        component: tocT9ExplainFreeCheck,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocT9CheckStandard',
        name: 'tocT9CheckStandard',
        component: tocT9CheckStandard,
        meta: {title: "268V检测报告"}
    },
    {
        path: '/tocT9explainFreeAuth',
        name: 'tocT9ExplainFreeAuth',
        component: tocT9ExplainFreeAuth,
        meta: {title: "268V检测报告"}
    },
    // 报告预览
    {
        path: '/reportConfirm',
        name: 'reportConfirm',
        component: reportConfirm,
        meta: {title: "检测信息确认"}
    },
    // 查看照片
    {
        path: '/photoView',
        name: 'photoView',
        component: photoView,
        meta: {title: "检测报告"}
    },
    // 复检差异
    {
        path: '/redetect',
        name: 'redetect',
        component: redetect,
        meta: {title: "复检差异"}
    },
    // 拆解教程
    {
        path: '/apartCourse',
        name: 'apartCourse',
        component: apartCourse,
        meta: {title: "拆解教程"}
    },
]


const router = createRouter({
    // history: createWebHashHistory(), // hash模式
    history: createWebHistory(process.env.VUE_APP_PUBLICPATH),
    routes
})
export default router
